















































































import { Component, Provide, Vue } from 'vue-property-decorator'
import { CompanyAPI } from '@/api/backend-client'
import { WidgetFlowType } from '@/api/types'
import { TypeformCredentials } from '@/api/model/credentials'
import { CredentialsType } from '@/api/types'

@Component
export default class CompanySettings extends Vue {
    loading: boolean = false

    @Provide()
    async reloadCompany(): Promise<void> {
        this.loading = true
        this.$root.$currentCompany = await CompanyAPI.get(this.$currentCompany.id, true)
        this.loading = false
    }

    get informationFlowActive(): boolean {
        return this.$currentCompany.activatedWidgetFlowTypes.includes(WidgetFlowType.INFORMATION)
    }

    get checklistFlowActive(): boolean {
        return this.$currentCompany.activatedWidgetFlowTypes.includes(WidgetFlowType.CHECKLIST)
    }

    get typeformFeatureEnabled(): boolean {
        return process.env.VUE_APP_TYPEFORM_FEATURE_ENABLED === 'true'
    }

    get pipelinesEnabled(): boolean {
        return this.$currentCompany.pipelinesEnabled
    }

    get typeformEnabled(): boolean {
        const credentials = this.$currentCompany.getCredentialsWithType(CredentialsType.TYPEFORM) as TypeformCredentials[]
        if (credentials.length === 0) {
            return false
        }

        return credentials[0].workspaceId !== null
    }
}
